// extracted by mini-css-extract-plugin
export default {"l":"bc160d8ce5"};